import RpIcon from "@/components/RpIcon.jsx";
import { MAX_WIDTH } from "@/constant/Constant";
import SimpleHeader from "@/pages/components/Headers/SimpleHeader.tsx";
import { Box, Drawer } from '@mui/material';
import { useTranslation } from "react-i18next";
import BillAddressForm from "../BillAddressForm";
import classes from './index.module.css';
import {enqueueSnackbar} from "notistack";

export default function BillAddressDialog({
                                            open,
                                            onClose,
  cardId,
                                          }) {
  const {t} = useTranslation();
  const onSuccess = () => {
    enqueueSnackbar(t("success"), {variant: 'success'})
    onClose && onClose();
  }
  // AppModal
  return (<>
    <Drawer anchor="right" open={open} onClose={onClose} title={t('billing_address')} PaperProps={{
      sx: { width: '100%', maxWidth: MAX_WIDTH }
    }}>
      {/*<SimpleHeader title={t('billing_address')}/>*/}
      {/*<Stack sx={{padding: '6px 16px'}} direction="row" alignItems="center" spacing={2}>*/}

      {/*  <Typography sx={{flex: 1, textAlign: 'center'}}>{t('billing_address')}</Typography>*/}
      {/*</Stack>*/}
      <SimpleHeader
        backEnable
          title={t('billing_address')}
          closeButton={<RpIcon icon="arrow-left" clickable onClick={() => {onClose()}}/>}
      />
      <Box className={classes.modalContent}>
        <BillAddressForm cardId={cardId} onSuccess={onSuccess}/>
      </Box>
    </Drawer>

  </>);
}
